eval("define(\'oroui/js/app/modules/ajax-error-module\',[\n    \'jquery\',\n    \'oroui/js/error\'\n], function($, error) {\n    \'use strict\';\n    $(document).ajaxError($.proxy(error.handle, error));\n});\n\n//# sourceURL=/var/www/vhosts/crm_multisite/web/bundles/oroui/js/app/modules/ajax-error-module.js");

